import dayjs from "dayjs";
import { FieldErrors, FieldValues } from "react-hook-form";

export const isValidEmail = (email: string, tillåtTomt = false): boolean => {
	if (!email)
		return tillåtTomt;

	let pattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
	return pattern.test(email);
}

export const isValidTelefonnummer = (nummer: string, tillåtTomt = false): boolean => {
	if (!nummer)
		return tillåtTomt;

	const cleaned = nummer.replace(/[\ \-()]/g, ""); //Ta bort -,(,) och mellanslag, för dem bryr vi oss inte om
	const pattern = /^[\+0]\d{7,14}$/; //Måste börja med + eller 0, och sedan 7-14 siffror
	return pattern.test(cleaned);
};

export const isValidSvenskMobiltelefon = (nummer: string, tillåtTomt = false): boolean => {
	if (!nummer)
		return tillåtTomt;

	const cleaned = nummer.replace(/[\ \-()]/g, ""); //Ta bort -,(,) och mellanslag, för dem bryr vi oss inte om
	const pattern = /^(\+46|0)7\d{8}$/; //Måste börja med +467 eller 07, och sedan 8 siffror
	return pattern.test(cleaned);
};


export const isValidPersonnummer = (pnr: string, tillåtTomt = false): boolean => {
	if (!pnr)
		return tillåtTomt;

	let personummer = formatString(pnr);
	if (personummer.length !== 10) {
		return false;
	}

	return isValidLuhn(personummer) //&& isFysiskPerson(personummer);
}

export const isValidSwedishPostnummer = (postnr: string, tillåtTomt = false) => {
	if (!postnr)
		return tillåtTomt;

	let pattern = /^\d{3}\s?\d{2}$/;
	return pattern.test(postnr);
}

export const isValidBirthDate = (birthDate: string, tillåtTomt = false): boolean => {
	return (tillåtTomt && !birthDate) || getValidBirthDate(birthDate) != null;
}

export function getValidBirthDate(dateString: string) {
	let str = dateString.replace(/\D/g, ""); //Ta bort allt som inte är siffror.
	if (str.length !== 6 && str.length !== 8)
		return null;
	if (str.length === 6) {
		let year = parseInt(str.slice(0,2));
		let currentYear = dayjs().year()-2000; //Obs, detta funkar bara fram till år 2099!
		if (year <= currentYear)
			str = "20" + str;
		else
			str = "19" + str;
	}

	const birthdate = dayjs(str);
	if (!birthdate.isValid())
		return null;

	//Det här blir _nästan_ rätt, men kan bli lite tokigt den dagen man fyller 120...
	const age = dayjs().diff(birthdate, "year", true);
	if (0 <= age && age <= 120)
		return birthdate;
	return null;
}

const formatString = (digitString: string): string => {
	let digits = digitString.replace(/\D/g, '');
	return digits.slice(digits.length - 10);
}

const isValidLuhn = (pnr: string): boolean => {
	let number;
	let checksum = 0;
	for (let i = pnr.length - 1; i >= 0; i--) {
		number = parseInt(pnr.charAt(i));
		if (i % 2 == 1) {
			checksum += number;
		} else {
			checksum += (number * 2) > 9 ? (number * 2) - 9 : number * 2;
		}
	}

	return checksum % 10 == 0;
}


export const validationCssClass = (formState: { errors: FieldErrors<FieldValues>, touchedFields: { [x: string]: any } }, fieldName: string): string => {

	if (!formState?.errors)
		return "";

	if (/^[\wÅÄÖåäö]+\.[\d]+\.[\wÅÄÖåäö]+$/.test(fieldName)) //nästlad fält, t.ex. personer.3.epost
	{
		const parts = fieldName.split(".");
		const topField = parts[0];
		const idx = parseInt(parts[1]);
		const subField = parts[2];

		const fieldErrors = formState.errors[topField] as any;

		if (fieldErrors && fieldErrors.length >= idx && fieldErrors[idx] && fieldErrors[idx][subField])
			return " is-invalid";
		else {
			const touchedFields = formState.touchedFields[topField] as any;
			if (touchedFields && touchedFields.length >= idx && touchedFields[idx] && touchedFields[idx][subField])
				return " is-valid";
		}
		return "";
	}
	else //enkelt fältnamn
	{
		if (formState?.errors[fieldName])
			return " is-invalid";
		else if (!formState?.errors[fieldName] && formState?.touchedFields[fieldName])
			return " is-valid";

		return "";
	}

}